import { NumberFieldInput } from '@hex/calculators-shared/components/NumberFieldInput';
import { Icon } from '@sapphire-react/core';
import { Stroller, Car } from '@sapphire/icons/react';
import { type Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  control: Control<any>;
};

export function HouseholdSection({ control }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <NumberFieldInput
        control={control}
        name={'children'}
        data-test-id={'children'}
        label={t('personalInformation.inputs.children.label')}
        width={'100%'}
        minValue={0}
        maxValue={6}
        showButtons
        affix={{
          prefix: (
            <Icon>
              <Stroller />
            </Icon>
          ),
        }}
      />
      <NumberFieldInput
        control={control}
        name={'cars'}
        data-test-id={'cars'}
        label={t('personalInformation.inputs.cars.label')}
        width={'100%'}
        minValue={0}
        maxValue={3}
        showButtons
        affix={{
          prefix: (
            <Icon>
              <Car />
            </Icon>
          ),
        }}
      />
    </>
  );
}
